<!-- Vertically anchored just under the header chat button via `store.triggerAnchor` (set by
     ChatTriggerComponent). Pinned to the viewport's own right edge rather than the button's —
     the button sits left of the profile cluster, so following it horizontally left the toast
     short of the corner instead of flush against it. -->
<div class="chat-toasts" [style.--toast-anchor-top.px]="store.triggerAnchor()?.top" role="region" aria-live="polite" aria-label="New chat messages">
  <button
    type="button"
    class="chat-toast"
    *ngFor="let toast of store.toasts(); trackBy: trackByToast"
    (click)="open(toast)"
    [attr.aria-label]="'Open message from ' + toast.title">
    <span class="chat-toast__icon" *ngIf="toast.is_group"><i class="pi pi-users"></i></span>
    <app-chat-avatar *ngIf="!toast.is_group" [name]="toast.sender_name" [avatar]="toast.avatar_url" [size]="34"></app-chat-avatar>

    <span class="chat-toast__body">
      <span class="chat-toast__title">{{ toast.title }}</span>
      <span class="chat-toast__text">{{ toast.body }}</span>
    </span>

    <!-- A span, not a nested button: a button inside a button is invalid and Chrome drops it -->
    <span class="chat-toast__close" (click)="dismiss($event, toast)" role="button" tabindex="0" aria-label="Dismiss">
      <i class="pi pi-times"></i>
    </span>
  </button>
</div>
